export default __webpack_public_path__ + "static/media/file.9ee6ec95.svg";